import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GA4SearchEvent, GtmEventType } from './gtmEventType';
import { mapSearchSourceToSearchType } from './gtmEventTypeHelper';

export class GtmSearchType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_SEARCH_DONE &&
            event.searchContext?.type === 'keyword' &&
            event.aiOverviewShown !== true
        );
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GA4SearchEvent {
        const { queryText, totals, searchSource } = event.searchContext;

        return {
            event: 'custEv_search',
            search_term: queryText,
            search_type: mapSearchSourceToSearchType(searchSource),
            search_category: 'all',
            search_result_count:
                (totals?.apps || 0) +
                (totals?.consultants || 0) +
                (totals?.agents || 0) +
                (totals?.slack || 0) +
                (totals?.externalAgents || 0),
            app_results: totals?.apps,
            consultant_results: totals?.consultants,
            agent_results: totals?.agents,
        };
    }
}
